module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Light.56fb8192.woff2";